module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAA/0lEQVQokX3SvytGYRjG8c/rVyFvmcRbErJLGUT5UWLyJ1hNZLBYlIHFwsZkRqJQJoWUv0YGC0K3nlOn0znvtZzOdV/f577O6ak1Gg3YwCqOcKqJWuv1ejueMIAVvOG1CgngBzMYRg3L+MBLFRDPqwQNJn8Rn3iuAmJ4hikMpdkCYvtjGRD6wjkmMZK8OXTgoQzIoAtMYDR5UbUft2VA6DttGsdY8uKAXty3NPvnBf1n20oGnbjEUs47wTp+ixu6cF0I72EtwsUN3bjBbM7bwW7+xAzowR2mc7Nt7Bf7ZkB0zoe3cFD25QHE5ZtP79FzE4dl4VB2+d7Rl2ocV4XhD1IWK3uQplZ3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/candlelight-more.png
// module id = v010
// module chunks = 9